import { render, staticRenderFns } from "./AppConfigCustomerInfoAdd.vue?vue&type=template&id=761dc52c&scoped=true&"
import script from "./AppConfigCustomerInfoAdd.vue?vue&type=script&lang=js&"
export * from "./AppConfigCustomerInfoAdd.vue?vue&type=script&lang=js&"
import style0 from "./AppConfigCustomerInfoAdd.vue?vue&type=style&index=0&id=761dc52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761dc52c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCol,VDialog,VFileInput,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('761dc52c')) {
      api.createRecord('761dc52c', component.options)
    } else {
      api.reload('761dc52c', component.options)
    }
    module.hot.accept("./AppConfigCustomerInfoAdd.vue?vue&type=template&id=761dc52c&scoped=true&", function () {
      api.rerender('761dc52c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/modal/AppConfigCustomerInfoAdd.vue"
export default component.exports